import { enteteTenant } from "../../../utils/enteteTenant";
// 🔴 ETI-101 — client HTTP des PORTES DE VALIDATION (VH1 / VH2 / VH3).
//
// 🔑 ⛔ AUCUNE LOGIQUE MÉTIER ICI : ce module ⛔ sait seulement OÙ le serveur
//    expose la lecture et la décision de chaque type d'entité. Quelle porte
//    s'applique, si elle est active, qui peut décider, ce qu'une décision
//    autorise ensuite : tout cela vient de la RÉPONSE du serveur
//    (`portes.etat_porte`), lui-même piloté par `tenants.config.portes`.
// ⛔ Aucun nom de tenant, aucune liste de tenants (témoin : PorteDecision.temoin.test.js).
const API = process.env.REACT_APP_BACKEND_URL || "";
const e = encodeURIComponent;

// Où vit chaque surface serveur. VH1 garde ses routes sous `/prospects`
// (effet de bord propre : le statut du prospect suit la décision) ; VH2/VH3
// sous `/portes/{type}/{id}` (`metier_hub/validation/routes.py`).
// ⚠️ La PORTE elle-même ⛔ n'est pas déduite ici : elle est lue dans l'état.
const SURFACES = {
  prospect: {
    lire: (id) => `/api/metier/prospects/${e(id)}/portes`,
    decider: (id, porte, acte) =>
      `/api/metier/prospects/${e(id)}/porte/${e(String(porte).toLowerCase())}/${acte}`,
  },
  dossier: {
    lire: (id) => `/api/metier/portes/dossier/${e(id)}`,
    decider: (id, porte, acte) => `/api/metier/portes/dossier/${e(id)}/${e(porte)}/${acte}`,
  },
  devis: {
    lire: (id) => `/api/metier/portes/devis/${e(id)}`,
    decider: (id, porte, acte) => `/api/metier/portes/devis/${e(id)}/${e(porte)}/${acte}`,
  },
};

export const ACTES = { valider: "valider", refuser: "refuser", rouvrir: "rouvrir" };

function entetes(tenantId) {
  let jeton = null;
  let slug = tenantId || "";
  try {
    jeton = localStorage.getItem("session_token");
    if (!slug) slug = localStorage.getItem("current_tenant_slug") || "";
  } catch { /* stockage indisponible */ }
  return {
    "Content-Type": "application/json",
    ...(slug && { ...enteteTenant(slug) }),
    ...(jeton && { Authorization: `Bearer ${jeton}` }),
  };
}

async function requete(chemin, tenantId, options = {}) {
  const r = await fetch(`${API}${chemin}`, {
    credentials: "include", headers: entetes(tenantId), ...options,
  });
  const corps = await r.json().catch(() => ({}));
  return { ok: r.ok, status: r.status, corps };
}

export function surfaceConnue(entiteType) {
  return Object.prototype.hasOwnProperty.call(SURFACES, entiteType);
}

/** L'état de la porte applicable à l'entité, TEL QUE RENDU par le serveur. */
export function lirePorte(entiteType, entiteId, tenantId) {
  return requete(SURFACES[entiteType].lire(entiteId), tenantId);
}

/** Pose une décision. ⚠️ Le serveur reste seul juge (rôle, motif, état). */
export function deciderPorte(entiteType, entiteId, porte, acte, motif, tenantId) {
  const corps = motif && motif.trim() ? { motif: motif.trim() } : {};
  return requete(SURFACES[entiteType].decider(entiteId, porte, acte), tenantId, {
    method: "POST", body: JSON.stringify(corps),
  });
}
